import React from 'react'
import { Button, Typography, Paper } from "@material-ui/core";
import { useRouter } from "@contexts/RouterProvider";
import { getAvailableResources } from '@models/admin'
import styles from "@styles/showPage";
import withStyles from "@material-ui/core/styles/withStyles";

const MainMenu = ({ classes, resources }) => {
  const router = useRouter();

  return (
    <Paper
      className={classes.showPage__wrapper}
      elevation={0}
    >
      <header className={classes.showPage__header}>
        <Typography component="h2" variant="h5">
          {I18n.t("v4/admin.show.title")}
        </Typography>
      </header>
      <main className={classes.showPage__value}>
        {getAvailableResources(resources).map((resource) => (
          <Button
            className={classes.showPage__value}
            onClick={() => router.visit(resource.link, resource.spa)}
            key={resource.id}
            variant="outlined"
            color="primary"
            fullWidth
          >
            {resource.label}
          </Button>
        ))}
      </main>
    </Paper>
  );
}

MainMenu.defaultProps = {
  resources: []
}

export default withStyles(styles)(MainMenu);
